function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from 'react';
import styled, { css } from 'styled-components';
import { neutral } from '../Color/withAlias';
const getCenterCSS = _ref2 => {
  let {
    size
  } = _ref2;
  return css(["position:absolute;position:absolute;top:50%;left:50%;margin:-", "px 0 0 -", "px;"], size / 2, size / 2);
};
const MySpinner = styled.svg.withConfig({
  displayName: "Spinner__MySpinner",
  componentId: "sc-7andmy-0"
})(["animation:rotate 2s linear infinite;", ";& .path{stroke:", ";stroke-linecap:round;animation:dash 1.5s ease-in-out infinite;}@keyframes rotate{100%{transform:rotate(360deg);}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0;}50%{stroke-dasharray:90,150;stroke-dashoffset:-35;}100%{stroke-dasharray:90,150;stroke-dashoffset:-124;}}"], props => props.center ? getCenterCSS({
  size: props.size
}) : '', neutral.loading);
const Spinner = _ref => {
  let {
      size = 24,
      strokeWidth
    } = _ref,
    props = _objectWithoutProperties(_ref, ["size", "strokeWidth"]);
  const strokeWidthDisplay = strokeWidth || size / 10;
  return React.createElement(MySpinner, _extends({
    viewBox: "0 0 50 50",
    width: size,
    height: size,
    size: size
  }, props), React.createElement("circle", {
    className: "path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    strokeWidth: strokeWidthDisplay
  }));
};
export default Spinner;